import { render, staticRenderFns } from "./TableServicesInactivesCallsList.vue?vue&type=template&id=e8f11d12"
import script from "./TableServicesInactivesCallsList.vue?vue&type=script&lang=js"
export * from "./TableServicesInactivesCallsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8f11d12')) {
      api.createRecord('e8f11d12', component.options)
    } else {
      api.reload('e8f11d12', component.options)
    }
    module.hot.accept("./TableServicesInactivesCallsList.vue?vue&type=template&id=e8f11d12", function () {
      api.rerender('e8f11d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableServicesInactivesCallsList.vue"
export default component.exports